<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @save="save" @add="add" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="InvCountViewInfo"
                        :filter_language="['Order_Status']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        @current-change="handleCurrentChanges"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        ref="singleTable"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false" width="20"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_No"  :label="$t('getapi[2315]')">
                       &lt;!&ndash; <template scope="scope">
                            <input type="text" class="fsd clerinput" @keydown="shows($event, scope.$index)"
                                   @keyup="show($event, scope)" v-model="scope.row.Order_No" readonly/>
                        </template> &ndash;&gt;
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Status"
                                    :label="$t('getapi[1861]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_type"
                                    :label="$t('getapi[2316]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="prior_count_time"
                                    :label="$t('getapi[2317]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="prior_count_person"
                                    :label="$t('getapi[2318]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="again_count_time"
                                    :label="$t('getapi[2319]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="again_count_person"
                                    :label="$t('getapi[2320]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time"
                                    :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person"
                                    :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Finance_Date"
                                    :label="$t('getapi[1857]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Keep_Person"
                                    :label="$t('getapi[1864]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Regist_Person"
                                    :label="$t('getapi[1747]')"></el-table-column>

                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div class="btnnowrap">
                    <el-button type="primary" size="mini" @click.native="mt8" :disabled="!btn.filterpart">{{$t('getapi[2344]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="RemarkDialogVisible=true" :disabled="!btn.remark">{{$t('getapi[3721]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="CloseDialogVisible=true" :disabled="!btn.closereason">{{$t('getapi[2337]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt3" :disabled="!btn.priorcountzero">{{$t('getapi[2338]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt4" :disabled="!btn.dopriorcount">{{$t('getapi[2339]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt5" :disabled="!btn.againcountzero">{{$t('getapi[2340]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt6" :disabled="!btn.doagaincount">{{$t('getapi[2341]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt7" :disabled="!btn.countverify">{{$t('getapi[2342]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt9" :disabled="!btn.closeorder">{{$t('getapi[2345]')}}
                    </el-button>
                    <!-- <el-button type="primary" size="mini" @click.native="mt10" :disabled="!btn.regist">执行记账
                    </el-button> -->

                    <el-button type="primary" size="mini" @click.native="mt11" :disabled="!btn.exceldata">{{$t('getapi[2346]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt12" :disabled="!btn.excelin">{{$t('getapi[2347]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="mt13" :disabled="!btn.getmodel">{{$t('getapi[2348]')}}
                    </el-button>
                </div>
                <div style="width:120px;min-width:120px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2350]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="newitem.Head.order_no" :placeholder="$t('getapi[2350]')"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2316]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-select v-model="newitem.Head.count_type" size="mini">
                                    <el-option value="0" :label="$t('getapi[162]')"></el-option>
                                    <el-option value="1" :label="$t('getapi[2323]')"></el-option>
                                </el-select>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[1861]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-if="newitem.Head.order_status == '-1'" :value="$t('getapi[1422]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-if="newitem.Head.order_status == 0" :value="$t('getapi[1422]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-if="newitem.Head.order_status == 1" :value="$t('getapi[2321]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-if="newitem.Head.order_status == 2" :value="$t('getapi[2322]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-if="newitem.Head.order_status == 3" :value="$t('getapi[3557]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[1862]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-if="newitem.Head.finance_status == 0" :value="$t('getapi[1901]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-if="newitem.Head.finance_status == 1" :value="$t('getapi[3753]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-if="newitem.Head.finance_status == 2" :value="$t('getapi[3754]')" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                                <el-input v-if="newitem.Head.finance_status == -1" value="" :placeholder="$t('getapi[1861]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span v-if="amountVisible">{{ $t('getapi[2349]') }}</span></td>
                            <td>
                                <el-input v-if="amountVisible" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="newitem.Head.amount" :placeholder="$t('getapi[2349]')"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[410]') }}</span></td>
                            <td>
                                <el-input v-model="newitem.Head.create_person" :placeholder="$t('getapi[410]')"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[135]') }}</span></td>
                            <td>
                                <el-input v-model="newitem.Head.create_time" :placeholder="$t('getapi[135]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[1857]') }}</span></td>
                            <td>
                                <el-input v-model="newitem.Head.finance_date" :placeholder="$t('getapi[1857]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--<div class="bbl">
                    <span>{{ $t('getapi[2350]') }}</span>
                    <el-input v-model="newitem.Head.order_no" :placeholder="$t('getapi[2350]')" style="width: 120px"
                              size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[2316]') }}</span>
                    &lt;!&ndash; <el-input v-model="newitem.Head.statusname" :placeholder="$t('getapi[2316]')" style="width: 60px" size="mini"> &ndash;&gt;
                    <el-select v-model="newitem.Head.count_type" style="width: 120px" size="mini">
                        <el-option value="0" :label="$t('getapi[162]')"></el-option>
                        <el-option value="1" :label="$t('getapi[2323]')"></el-option>
                    </el-select>
                    &lt;!&ndash; </el-input> &ndash;&gt;
                    <span>{{ $t('getapi[1861]') }}</span>
                    <el-input v-if="newitem.Head.order_status == '-1'" :value="$t('getapi[1422]')" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-input v-if="newitem.Head.order_status == 0" :value="$t('getapi[1422]')" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-input v-if="newitem.Head.order_status == 1" :value="$t('getapi[2321]')" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-input v-if="newitem.Head.order_status == 2" :value="$t('getapi[2322]')" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-input v-if="newitem.Head.order_status == 3" :value="$t('getapi[3557]')" :placeholder="$t('getapi[1861]')"
                    style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>

                    <span>{{ $t('getapi[1862]') }}</span>
                    <el-input v-if="newitem.Head.finance_status == 0" :value="$t('getapi[1901]')" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-input v-if="newitem.Head.finance_status == 1" :value="$t('getapi[3753]')" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-input v-if="newitem.Head.finance_status == 2" :value="$t('getapi[3754]')" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <el-input v-if="newitem.Head.finance_status == -1" value="" :placeholder="$t('getapi[1861]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                </div>
                <div class="bbl">
                    <span v-if="amountVisible">{{ $t('getapi[2349]') }}</span>
                    <el-input v-if="amountVisible" type="number" @mousewheel.native.prevent v-model="newitem.Head.amount" :placeholder="$t('getapi[2349]')" style="width: 120px;"
                              size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[410]') }}</span>
                    <el-input v-model="newitem.Head.create_person" :placeholder="$t('getapi[410]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[135]') }}</span>
                    <el-input v-model="newitem.Head.create_time" :placeholder="$t('getapi[135]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[1857]') }}</span>
                    <el-input v-model="newitem.Head.finance_date" :placeholder="$t('getapi[1857]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                </div>-->
                <div>
                    <br/>
                    <el-button type="primary" size="mini" @click.native="delAll" :disabled="!btn.rowdel">{{$t('getapi[3889]')}}
                    </el-button>
                </div>

                <el-tabs @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[2351]')" name="0" id="xdetilpane-0">
                        <el-table v-loading="dloading" :data="list1" border :height="tableHeight - 210" size="mini"
                                 header-row-class-name="headerclass" style="width: 100%;" :row-class-name="tableRowClassNameRight" @selection-change="handleSelectionChange"
                                  :header-cell-style="$limits.headerClass"
                                  ref="singleTable1">
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column prop="line_status_name" :label="$t('getapi[552]')"
                                            width="100">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.line_status_name | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[1513]')"
                                            width="120"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"
                                            width="120"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[4522]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[3100]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="prior_qty" :label="$t('getapi[2327]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column prop="prior_actually_qty" :label="$t('getapi[2329]')"
                                            align="right" width="100">
                            <template slot-scope="scope">
											<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="newitem.Head.order_status == 0" v-model="scope.row.prior_actually_qty"></el-input>
											<span v-if="newitem.Head.order_status != 0">{{ scope.row.prior_actually_qty }}</span>
							</template>
                                            
                            </el-table-column>
                            <el-table-column prop="again_actually_qty" :label="$t('getapi[2331]')"
                                            align="right" width="100">
                            <template slot-scope="scope">
											<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="newitem.Head.order_status == 1" v-model="scope.row.again_actually_qty"></el-input>
											<span v-if="newitem.Head.order_status != 1">{{ scope.row.again_actually_qty }}</span>
							</template>
                            
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="diff_qty" :label="$t('getapi[2333]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[1410]')"
                                            align="right" width="150" v-if="amountVisible"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_net_total_amount"
                                            :label="$t('getapi[2102]')" align="right" width="100" v-if="amountVisible"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[439]')" align="right"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issequencetrace " :label="$t('getapi[6427]')" align="right"
                                            width="100"></el-table-column>
                            <el-table-column :label="$t('getapi[6048]')" width="70" align="center">
                                <template slot-scope="scope">
                                    <el-button v-if="newitem.Head.order_status < 1" :disabled="!btn.rowdel"
                                               @click.native.prevent="delline1(scope)" type="text" size="small">
                                        {{ $t('getapi[40]') }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[4524]')" name="1" id="xdetilpane-1">
                        <el-table v-loading="dloading" :data="list2" border :height="tableHeight - 210" size="mini"
                                 header-row-class-name="headerclass" style="width: 100%;" :row-class-name="tableRowClassNameRightAssist" @selection-change="handleSelectionChangeAssist"
                                  :header-cell-style="$limits.headerClass"
                                  ref="singleTable2">
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column prop="line_status_name" :label="$t('getapi[552]')"
                                            width="100">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.line_status_name | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[1513]')"
                                            width="120"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"
                                            width="120"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[4522]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[3100]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="prior_qty" :label="$t('getapi[2327]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="assist_prior_qty" :label="$t('getapi[2352]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column prop="prior_actually_qty" :label="$t('getapi[2329]')"
                                            align="right" width="100">
                            <template slot-scope="scope">
											<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="newitem.Head.order_status == 0" v-model="scope.row.prior_actually_qty"></el-input>
											<span v-if="newitem.Head.order_status != 0">{{ scope.row.prior_actually_qty }}</span>
							</template>
                            </el-table-column>
                            <el-table-column prop="assist_prior_actually_qty"
                                            align="right" :label="$t('getapi[2353]')" width="100">
                            <template slot-scope="scope">
											<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="newitem.Head.order_status == 0" v-model="scope.row.assist_prior_actually_qty" @input="calculateC(scope)"></el-input>
											<span v-if="newitem.Head.order_status != 0">{{ scope.row.assist_prior_actually_qty }}</span>
							</template>
                            </el-table-column>
                            <el-table-column prop="again_actually_qty" :label="$t('getapi[2331]')"
                                            align="right" width="100">
                            <template slot-scope="scope">
											<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="newitem.Head.order_status == 1" v-model="scope.row.again_actually_qty"></el-input>
											<span v-if="newitem.Head.order_status != 1">{{ scope.row.again_actually_qty }}</span>
							</template>
                            </el-table-column>
                            <el-table-column prop="assist_again_actually_qty"
                                            align="right" :label="$t('getapi[2354]')" width="100">
                            <template slot-scope="scope">
											<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="newitem.Head.order_status == 1" v-model="scope.row.assist_again_actually_qty" @input="calculateF(scope)"></el-input>
											<span v-if="newitem.Head.order_status != 1">{{ scope.row.assist_again_actually_qty }}</span>
							</template>
                            
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="diff_qty" :label="$t('getapi[2333]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="assist_diff_qty" :label="$t('getapi[2355]')"
                                            align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[1410]')"
                                            align="right" width="150" v-if="amountVisible"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_net_total_amount"
                                            align="right" :label="$t('getapi[2102]')" width="100" v-if="amountVisible"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[439]')"
                                            width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issequencetrace " :label="$t('getapi[6427]')" align="right"
                                            width="100"></el-table-column>
                            <el-table-column :label="$t('getapi[6048]')" width="70" align="center">
                                <template slot-scope="scope">
                                    <el-button v-if="newitem.Head.order_status < 1" :disabled="!btn.rowdel"
                                               @click.native.prevent="delline2(scope)" type="text" size="small">
                                        {{ $t('getapi[40]') }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6421]')">
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadurl"
                                :on-preview="handlePreview_"
                                :on-remove="handleRemove_"
                                :on-change="handleChange_"
                                :on-success="handleSuccess_"
                                :on-error="handleError_"
                                :before-upload="beforeAvatarUpload_"
                                :file-list="fileList"
                                :data="fileparm"
                                :limit="1"
                        >
                            <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
                            <div slot="tip" class="el-upload__tip"></div>
                        </el-upload>
                        <el-table
                                :data="newitem.Attrs"
                                v-loading="loading"
                                :height="tableHeight - 230"
                                :highlight-current-row="false"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                header-row-class-name="headerclass"
                        >
                            <el-table-column show-overflow-tooltip prop="node_nmae" :label="$t('getapi[3590]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="doc_type" :label="$t('getapi[6423]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="doc_size" :label="$t('getapi[7875]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="upload_person" :label="$t('getapi[6425]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="upload_time" :label="$t('getapi[6426]')"></el-table-column>
                            <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="open(scope)" type="text" size="mini">{{ $t('getapi[3611]') }}</el-button>
                                    <el-button @click.native.prevent="filedel(scope)" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
                <div style="width:800px;min-width:800px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2359]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="newitem.Head.prior_count_person" :placeholder="$t('getapi[2359]')"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2317]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="newitem.Head.prior_count_time" :placeholder="$t('getapi[2317]')"
                                         size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2357]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="newitem.Head.again_count_person" :placeholder="$t('getapi[2357]')"
                                           size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2319]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="newitem.Head.again_count_time" :placeholder="$t('getapi[2319]')"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[2356]') }}</span></td>
                            <td><el-input v-model="newitem.Head.close_person" :placeholder="$t('getapi[2356]')"
                                           size="mini" :readonly="true" class="readO"></el-input></td>
                            <td><span>{{ $t('getapi[2358]') }}</span></td>
                            <td><el-input v-model="newitem.Head.close_time" :placeholder="$t('getapi[2358]')"
                                           size="mini" :readonly="true" class="readO"></el-input></td>
                            <td><span>{{ $t('getapi[1864]') }}</span></td>
                            <td>
                                <routejump :urlNo="6">
                                <el-input
                                    v-model="newitem.Head.keep_person"
                                    size="mini"
                                    readonly
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen(0)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td><span>{{ $t('getapi[1747]') }}</span></td>
                            <td>
                                <routejump :urlNo="6">
                                <el-input
                                        v-model="newitem.Head.regist_person"
                                        size="mini"
                                        readonly
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen(1)"></i>
                                </el-input>
                                </routejump>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--<div class="bbl">
                    <span>{{ $t('getapi[2359]') }}</span>
                    <el-input v-model="newitem.Head.prior_count_person" :placeholder="$t('getapi[2359]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[2317]') }}</span>
                    <el-input v-model="newitem.Head.prior_count_time" :placeholder="$t('getapi[2317]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[2357]') }}</span>
                    <el-input v-model="newitem.Head.again_count_person" :placeholder="$t('getapi[2357]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[2319]') }}</span>
                    <el-input v-model="newitem.Head.again_count_time" :placeholder="$t('getapi[2319]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                </div>
                <div class="bbl">
                    <span>{{ $t('getapi[2356]') }}</span>
                    <el-input v-model="newitem.Head.close_person" :placeholder="$t('getapi[2356]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[2358]') }}</span>
                    <el-input v-model="newitem.Head.close_time" :placeholder="$t('getapi[2358]')"
                              style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    <span>{{ $t('getapi[1864]') }}</span>
                    <el-input
                            v-model="newitem.Head.keep_person"
                            style="width:120px"
                            size="mini"
                            readonly
                    >
                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen(0)"></i>
                    </el-input>
                    <span>{{ $t('getapi[1747]') }}</span>
                    <el-input
                            v-model="newitem.Head.regist_person"
                            style="width:120px"
                            size="mini"
                            readonly
                    >
                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen(1)"></i>
                    </el-input>
                </div>-->
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="InvCountViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[980]')" queryData="InvCountViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 人员弹框 -->
        <!-- <employee :isVisible="false" @getemployee3="getemployee3" ref="input"></employee> -->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee3" ref="input"></selector>
        <!-- 导入数据 -->
        <el-dialog v-dialogDrag :visible.sync="isuplod">
            <el-row>
                <el-col :span="24" style="text-align: center;height: 250px;">
                    <el-upload
                            class="upload-demo"
                            drag
                            :action="uploarurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog v-dialogDrag
            :title="$t('getapi[143]')"
            :visible.sync="RemarkDialogVisible"
            width="30%"
            >
            <el-input
            type="textarea"
            :rows="5"
            v-model="newitem.Head.remark">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="RemarkDialogVisible = false">{{$t('getapi[6]')}}</el-button>
                <el-button type="primary" @click="mt1">{{$t('getapi[1146]')}}</el-button>
            </span>
            </el-dialog>
        <el-dialog v-dialogDrag
            :title="$t('getapi[2337]')"
            :visible.sync="CloseDialogVisible"
            width="30%"
            >
            <el-input
            type="textarea"
            :rows="5"
            v-model="newitem.Head.close_reason">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="mt2">{{$t('getapi[1146]')}}</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'InvCheckView',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                RemarkDialogVisible:false,//查看备注弹框 显隐
                CloseDialogVisible:false,//强制关闭弹框 显示与隐藏
                IsCloseByApi:false,//强制关闭是否调用接口
                uploarurl: '',
                showloading: '',
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                isuplod: false, //上传文件
                UploadFileUrl: '', //文件路径
                queryData: [], // 查询数组 左侧列表
                queryDataRight: [], // 查询数组 右侧查询后选择列表
                userData: {}, // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('InvCheckView'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dloading: false, // 子表加载状态
                isShowEdit: false, // 是否显示编辑页面
                list1: [],
                list2: [],
                line_no_index:0,//行号
                dataDetail: {
                    Head: {},
                    Lists: []
                }, // 编辑页面数据详情
                newitem: {
                    Head: {
                        order_no: '',
                        order_status: -1,
                        count_type: '',
                        prior_count_time: '',
                        prior_count_person: '',
                        again_count_time: '',
                        again_count_person: '',
                        create_person: '',
                        create_time: '',
                        remark: '',
                        finance_status: 0,
                        finance_date: '',
                        count_date: '',
                        close_person: '',
                        close_time: '',
                        close_reason: '',
                        keep_person: '',
                        regist_person: ''
                    },
                    Lists: [
                        {
                            exclusively_id: 0,
                            relation_order_no: '',
                            line_status: 0,
                            line_status_name: '',
                            part_code: '',
                            part_name: '',
                            part_version: '',
                            cargo_position: '',
                            batch_no: '',
                            sequence_no: '',
                            line_no: 0,
                            measureunit: '',
                            prior_qty: 0,
                            prior_actually_qty: 0,
                            again_actually_qty: 0,
                            diff_qty: 0,
                            assist_measureunit: '',
                            assist_prior_qty: 0,
                            assist_prior_actually_qty: 0,
                            assist_again_actually_qty: 0,
                            assist_diff_qty: 0,
                            relation_onhand_id: 0,
                            workproc_id: 0,
                            line_net_total_amount: 0,
                            unit_price: 0,
                            issue_material_unit: 0,
                            issue_man_unit: 0,
                            issue_charge_unit: 0,
                            issue_material_amount: 0,
                            issue_man_amount: 0,
                            issue_charge_amount: 0,
                            issequencetrace: true
                        }
                    ],
                    Attrs: []
                }, //详情页面数据
                oldNewitem: '',
                repuser: 0,
                mt8def: false, //是否选择盘点条件
                PlanTypeArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                currentRow: null,
                lineid: [],
                btn: {
                    //备注
                    remark: false,
                    //关闭原因
                    closereason: false,
                    //初盘无差异
                    priorcountzero: false,
                    //初盘确认
                    dopriorcount: false,
                    //复盘无差异
                    againcountzero: false,
                    //复盘确认
                    doagaincount: false,
                    //盘点核准
                    countverify: false,
                    //筛选查询
                    query: false,
                    //选择盘点条件
                    filterpart: false,
                    //强制关闭
                    closeorder: false,
                    //执行记账
                    regist: false,
                    //取得Excel数据
                    exceldata: false,
                    //数据导入
                    excelin: false,
                    //取得导入模板
                    getmodel: false,
                    //明细删除
                    rowdel: false
                },
                multipleSelectionMain :[],
                multipleSelectionAssist :[],
                amountVisible:false,
                // 上传清单
                uploadurl: '',
                fileparm: {
                    code: '',
                    data_type: 10,
                },
                fileList: [],
                oldrow: '',
                iscontinuedblclick: true,
                code: '',
                RightSelectIndex: '0',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Basic/UploadFilesResult?token=' + token;
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('InvCheckView', that)
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploarurl = Common.Url + '/Inv/Check/InvCountUpFile?token=' + token;
            that.PlanTypeArray = Array.methods.getPlanType();
            that.$limits.dragControllerDiv();
            that.oldNewitem = JSON.stringify(that.newitem)
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('InvCountViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[980]"),this.$t("getapi[15]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority(type) {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                let limits=1;
                let isLeftControl = false;//通过左侧权限
                if(!this.$limits.menuvisible("plv2", 82, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 81, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 82, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 82, 1) == 2) {
                        //操作权
                        if (that.$limits.authority('plv3', 82,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        if (that.$limits.authority('plv3', 82,1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.newitem.Head.order_no)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,execute');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                            limits=2;
                        }
                        if (that.$limits.authority('plv3', 82, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.newitem.Head.order_no)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                            limits=3;
                        }
                    }
                }
                if(limits==-1||limits==1)that.closeAllRightButton();
                else that.btnauthority();
                 //金额显影
                if (that.$limits.authority('plv4', 317, 1) == 0) {
                    that.amountVisible = false;
                }else{
                    that.amountVisible = true;
                }
            },
            btnauthority() {
                let that = this;
                console.log('状态:' + that.newitem.Head.order_status);
                if (!that.$limits.fnIsEmpty(that.newitem.Head.order_no) || that.newitem.Head.order_status == 1) {
                    that.btn.move = false;
                }
                //选择盘点条件
                that.btn.filterpart = true;
                if (that.$limits.fnIsEmpty(that.newitem.Head.order_no)) {
                    that.btn.rowdel = true;
                    //选择盘点条件
                    that.btn.filterpart = true;
                    //删除明细
                    that.btn.rowdel = true;
                    if (that.$limits.authority('plv2', 82, 1) == 2) {
                        //操作权
                        if (that.$limits.authority('plv3', 82, 1) > 0) {
                            //编辑级
                            //取得导入模板
                            that.btn.getmodel = true;
                        }
                    }
                } else {
                    that.btn.filterpart = false;
                    that.btn.rowdel = false;
                    //备注
                    that.btn.remark = true;
                    //关闭原因
                    that.btn.closereason = true;
                    console.log('状态:' + that.newitem.Head.order_status);
                    switch (that.newitem.Head.order_status) {
                        case 0://生成
                            //初盘无差异
                            if (that.$limits.authority('plv4', 44, 1) == 1){
                                that.btn.priorcountzero = true;
                            }
                            //初盘确认
                            that.btn.dopriorcount = true;
                            //复盘无差异
                            that.btn.againcountzero = false;
                            //复盘确认
                            that.btn.doagaincount = false;
                            //盘点核准
                            that.btn.countverify = false;
                            that.btn.closeorder = true;
                            break;
                        case 1://初盘
                            //初盘无差异
                            that.btn.priorcountzero = false;
                            //初盘确认
                            that.btn.dopriorcount = false;
                            //复盘无差异
                            if (that.$limits.authority('plv4', 45, 1) == 1){
                                that.btn.againcountzero = true;
                            }
                            //复盘确认
                            that.btn.doagaincount = true;
                            //盘点核准
                            that.btn.countverify = false;
                            that.btn.closeorder = true;
                            break;
                        case 2://复盘
                            //初盘无差异
                            that.btn.priorcountzero = false;
                            //初盘确认
                            that.btn.dopriorcount = false;
                            //复盘无差异
                            that.btn.againcountzero = false;
                            //复盘确认
                            that.btn.doagaincount = false;

                            if (that.$limits.authority('plv4', 46, 1) == 1) {
                                //盘点核准
                                that.btn.countverify = true;
                            } else {
                                //盘点核准
                                that.btn.countverify = false;
                            }
                            that.btn.closeorder = true;
                            break;
                        case 3://关闭
                            //初盘无差异
                            that.btn.priorcountzero = false;
                            //初盘确认
                            that.btn.dopriorcount = false;
                            //复盘无差异
                            that.btn.againcountzero = false;
                            //复盘确认
                            that.btn.doagaincount = false;
                            //盘点核准
                            that.btn.countverify = false;
                            that.btn.closeorder = false;
                            that.btn.filterpart = false;//选择盘点条件 关闭
                            
                            break;
                    }

                    if (that.newitem.Head.finance_status == 2) {
                        that.btn.regist = false;
                    } else {
                        that.btn.regist = true;
                    }

                    if (that.$limits.authority('plv2', 82, 1) == 2) {
                        //操作权
                        if (that.$limits.authority('plv3', 82, 1) > 0) {
                            if (that.list1.length == 0 && that.list2.length == 0) {
                                //取得Excel数据
                                that.btn.exceldata = true;
                                //数据导入
                                that.btn.excelin = true;
                            }
                        }
                    }
                }
               
            },
            handleChange_(file, fileList) {
                let that = this;
                console.log('------handleChange---', file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        //
                        // that.datajson = file.response.DataContent;
                    }
                }
            },
            handleSuccess_(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    let parm = {
                        Order_No: that.newitem.Head.order_no,
                    };
                    that.getDetail(parm);
                    that.$refs.upload.clearFiles();
                }
            },
            handleError_(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove_(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview_(file) {
                let that = this;
                that.fileparm.code = that.newitem.Head.order_no;
                console.log('---handlePreview--', that.fileparm);
                console.log(file);
            },
            beforeAvatarUpload_(file) {
                let that = this;
                that.fileparm.code = that.newitem.Head.order_no;
                if (that.newitem.Head.order_no == '' || that.newitem.Head.order_no == null) {
                    that.$message.error(that.$t('getapi[8619]'));//单据号不能为空
                    return false;
                }
                return true;
            },
            open(row) {
                let that = this;
                if(!that.$limits.fnIsEmpty(row.row.path)){
                    window.open(Common.Url + row.row.path);
                }
            },
            //删除文件
            filedel(row) {
                let that = this;
                let index = row.$index;
                that.ids = '';
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.path == 'undefined' ? '' : row.row.path;
                        let parm = {
                            ids: row.row.node_id,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                                that.newitem.Attrs.splice(index, 1);
                            }
                        });
                    })
                    .catch(() => {});
            },
            closeAllRightButton(){
                let that = this;
                that.btn.remark = false;
                //关闭原因
                that.btn.closereason= false;
                //初盘无差异
                that.btn.priorcountzero= false;
                //初盘确认
                that.btn.dopriorcount= false;
                //复盘无差异
                that.btn.againcountzero= false;
                //复盘确认
                that.btn.doagaincount= false;
                //盘点核准
                that.btn.countverify= false;
                //筛选查询
                that.btn.query= false;
                //选择盘点条件
                that.btn.filterpart= false;
                //强制关闭
                that.btn.closeorder= false;
                //执行记账
                that.btn.regist= false;
                //取得Excel数据
                that.btn. exceldata= false;
                //数据导入
                that.btn.excelin= false;
                //取得导入模板
                that.btn.getmodel= false;
                //明细删除
                that.btn.rowdel= false;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('InvCheckView',val)
                this.intidata();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.intidata();
            },
            
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.mt8def = false;
                that.$refs.ser.clearInput(that.isVisible, 'InvCountViewInfo');
            },
            //人员
            conopen(e) {
                if(!this.isEdit||this.newitem.Head.order_status==0){
                    this.repuser = e;
                    this.$refs.input.clearInputFromFunc(true, false, 3);
                }
            },
            getemployee3(e) {
                console.log(e);
                if (this.repuser == 0) {
                    this.newitem.Head.keep_person = e.name;
                } else {
                    this.newitem.Head.regist_person = e.name;
                }
            },
            //获取查询条件
            serclick(val) {
                
                this.pageIndex = 1;
                if (this.mt8def) {//右侧查询
                    this.queryDataRight = val;
                    this.getinvmeter();
                } else {//左侧查询
                    this.queryData = val;
                    this.confirmGetView();
                }
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.intidata();
            },
            // 数据一览
            intidata() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                console.log(data);
                that.$http.urlpost('/Inv/Check/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            handleCommand() {
            },
            editInfo(row){
                let that = this;
                if(that.code == row.Order_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 82, 1)){
                        return
                    }
                    let datacopy = {
                        Head: {},
                        Lists: [],
                        Attrs:[]

                    }
                    datacopy.Head = that.newitem.Head
                    if (that.list1) {
                        for(let i = 0;i<that.list1.length;i++){
                            datacopy.Lists.push(that.list1[i]);
                        }
                    }
                    if (that.list2) {
                        for(let i = 0;i<that.list2.length;i++){
                            datacopy.Lists.push(that.list2[i]);
                        }
                    }
                    datacopy.Attrs= that.newitem.Attrs;
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    console.log(that.oldNewitem)
                    console.log(JSON.stringify(datacopy))
                    if(that.oldNewitem != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.Order_No
                                let parm = {
                                    Order_No: row.Order_No
                                }
                                that.getDetail(parm)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.Order_No
                        let parm = {
                            Order_No: row.Order_No
                        }
                        that.getDetail(parm)
                    }
                }, 100);
            },
            //左边点击
            getDetail(row) {
                let that = this
                if(that.dloading) return;
                console.log(row);
                that.list2 = [];
                that.list1 = [];
                let parm = {
                    Code: row.Order_No
                };
                that.dloading  = true;
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Inv/Check/GetInvCountBillInfo', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.list2 = [];
                        that.list1 = [];
                        delete res.DataContent.LangType
                        that.newitem = res.DataContent;
                        for(let i=0;i<res.DataContent.Lists.length;i++){
                            let item =  res.DataContent.Lists[i];
                            //if(item.prior_actually_qty==0)item.prior_actually_qty='';
                            if (item.assist_measureunit) {
                                that.list2.push(item);
                            } else {
                                that.list1.push(item);
                            }
                        }
                        that.isShowEdit = true;
                        that.isEdit = true;
                        that.datacopy=that.newitem;
                        that.oldNewitem = JSON.stringify(that.newitem)
                        that.authority(2);
                        that.$nextTick(function() {
                            that.$processdata.initFormRight(this.RightSelectIndex)
                        })
                    }
                    that.dloading  = false;
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = {
                    Head: {},
                    Lists: [],
                    Attrs:[]

                }
                datacopy.Head = that.newitem.Head
                if (that.list1) {
                    for(let i = 0;i<that.list1.length;i++){
                        datacopy.Lists.push(that.list1[i]);
                    }
                }
                if (that.list2) {
                    for(let i = 0;i<that.list2.length;i++){
                        datacopy.Lists.push(that.list2[i]);
                    }
                }
                datacopy.Attrs= that.newitem.Attrs;
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                
                if(that.oldNewitem != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.isEdit = false;
                that.isShowEdit = true;
                that.list1 = [];
                that.list2 = [];
                that.code = '',
                that.line_no_index=0;
                that.newitem = {
                    Head: {
                        order_no: '',
                        order_status: -1,
                        count_type: '',
                        prior_count_time: '',
                        prior_count_person: '',
                        again_count_time: '',
                        again_count_person: '',
                        create_person: '',
                        create_time: '',
                        remark: '',
                        finance_status: 0,
                        finance_date: '',
                        count_date: '',
                        close_person: '',
                        close_time: '',
                        close_reason: '',
                        keep_person: '',
                        regist_person: ''
                    },
                    Lists: []
                };
                that.oldNewitem = JSON.stringify(that.newitem)
                that.authority(2);
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = {
                    Head: {},
                    Lists: [],
                    Attrs:[]

                }
                datacopy.Head = that.newitem.Head
                if (that.list1) {
                    for(let i = 0;i<that.list1.length;i++){
                        datacopy.Lists.push(that.list1[i]);
                    }
                }
                if (that.list2) {
                    for(let i = 0;i<that.list2.length;i++){
                        datacopy.Lists.push(that.list2[i]);
                    }
                }
                datacopy.Attrs= that.newitem.Attrs;
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }

                // console.log("oldNewitem数据:"+that.oldNewitem)
                // console.log("datacopy数据:"+JSON.stringify(datacopy))

                if(that.oldNewitem != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.intidata();
                            //刷右边
                            if(!that.$limits.fnIsEmpty(that.newitem.Head.order_no)){
                                let rowtmp={
                                    Order_No:that.newitem.Head.order_no
                                }
                                that.getDetail(rowtmp);
                            }else{
                                //清空右边
                                that.confirmAdd();
                            }
                        });
                } else {
                    that.intidata();
                    //刷右边
                    if(!that.$limits.fnIsEmpty(that.newitem.Head.order_no)){
                        let rowtmp={
                            Order_No:that.newitem.Head.order_no
                        }
                        that.getDetail(rowtmp);
                    }else{
                        //清空右边
                        that.confirmAdd();
                    }
                }
            },
            calculateC(row){
			//根据次计量 算出主计量数量
			let that = this
			let index = row.$index
			let qty = that.list2[index].master_assist_rate * that.list2[index].assist_prior_actually_qty;
			that.list2[index].prior_actually_qty = qty.toFixed(4);
            },
            calculateF(row){
			//根据次计量 算出主计量数量 master_assist_rate
            let that = this;
            let index = row.$index;
            let qty = that.list2[index].master_assist_rate * that.list2[index].assist_again_actually_qty;
            that.list2[index].again_actually_qty = qty.toFixed(4);
            },
            // 导出
            exps() {
               /* let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                that.$http.urlpost('/Inv/Check/ExportToExecl', data, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "InvCountViewInfo",
                    fromname: that.$t('getapi[980]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = {
                    Head: {},
                    Lists: [],
                    LangType:that.$processdata.getLang(),
                };
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                //行号重复校验
                // let arrtemp=[];
                // for(let k=0;k<parm.detail.length;k++){
                //     arrtemp.push(parm.detail[k].routing_sequence);
                // }
                // if(that.$limits.isRepeatJ(arr)){
                //     that.$message.warning("行号不能重复！");
                //     that.$refs.SetBtn.SetOneBtnEnable('save', true);
                //     return;
                // }
                parm.Head = that.newitem.Head;
                if (that.list1) {
                    that.list1.forEach(item => {
                        parm.Lists.push(item);
                    });
                }
                if (that.list2) {
                    that.list2.forEach(item => {
                        parm.Lists.push(item);
                    });
                }
                // console.log(JSON.stringify(parm));
                that.$http.urlpost('Inv/Check/InvCountSaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let rowtmp={
                            Order_No:res.UniqueNum
                        }
                        that.getDetail(rowtmp)//刷右边
                        that.authority(2);
                    }
                });
            },
            //删除
            delline1(row) {
                let index = row.$index;
                this.list1.splice(index, 1);
            },
            delline2(row) {
                let index = row.$index;
                this.list2.splice(index, 1);
            },
            tableRowClassNameRight({ row, rowIndex }) {
            row.index = rowIndex;
            },
            tableRowClassNameRightAssist({ row, rowIndex }) {
            row.index = rowIndex;
            },
            //批量删除
            delAll(){
                let that = this;
                for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                that.list1.splice(that.multipleSelectionMain[i].index, 1);
                }
                for (let i = that.multipleSelectionAssist.length - 1; i >= 0; i--) {
                that.list2.splice(that.multipleSelectionAssist[i].index, 1);
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                //let that = this;
                this.multipleSelectionMain = val;
            },
            handleSelectionChangeAssist(val) {
                //let that = this;
                this.multipleSelectionAssist = val;
            },
            //操作菜单
            //选择盘点条件
            getinvmeter() {
                let that = this;
                
                let datac = [];
                for (let i = 0; i < that.queryDataRight.length; i++) {
                    datac.push({
                        query_Condition: that.queryDataRight[i].query_Condition,
                        query_field_type: that.queryDataRight[i].Query_Field_Type,
                        query_field_name: that.queryDataRight[i].Query_Field_Name,
                        query_sort: that.queryDataRight[i].query_sort,
                        row_sign: that.queryDataRight[i].row_sign
                    });
                }
                that.dloading = true;
                that.$http.urlpost('Inv/Check/GetInvMaterialDataList', datac, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        console.log(res);
                        let data = res.DataContent.DataList;
                        let CanAddData=[];//可以被加入的集合
                        let currentdatalist = that.list1.concat(that.list2);
                        //求相对补集
                        //data-currentdatalist; 返回数据总集合-currentdatalist
                        if(currentdatalist.length > 0) {
                            CanAddData = data.filter(item => {
                                return currentdatalist.every(item2 => {
                                    return item.exclusively_id != item2.tmp_exclusively_id;
                                });
                            });
                           
                        }else{
                            CanAddData = data;
                        }
                        
                        CanAddData.forEach(function (item, index) {
                            that.line_no_index++;
                            if(!that.$limits.fnIsEmpty(item.mtl_assist_unit)){
                                let list = {
                                    exclusively_id: 0,
                                    relation_order_no: '',
                                    line_status: 0,
                                    line_status_name: '生成',
                                    part_code: '',
                                    part_name: '',
                                    part_version: '',
                                    cargo_position: '',
                                    batch_no: '',
                                    sequence_no: '',
                                    line_no: that.line_no_index,
                                    measureunit: '',
                                    prior_qty: 0,
                                    prior_actually_qty: 0,
                                    again_actually_qty: 0,
                                    diff_qty: 0,
                                    assist_measureunit: '',
                                    assist_prior_qty: 0,
                                    assist_prior_actually_qty: 0,
                                    assist_again_actually_qty: 0,
                                    assist_diff_qty: 0,
                                    relation_onhand_id: 0,
                                    workproc_id: 0,
                                    line_net_total_amount: 0,
                                    unit_price: 0,
                                    issue_material_unit: 0,
                                    issue_man_unit: 0,
                                    issue_charge_unit: 0,
                                    issue_material_amount: 0,
                                    issue_man_amount: 0,
                                    issue_charge_amount: 0,
                                    issequencetrace: true
                                };
                                list.relation_onhand_id=item.exclusively_id;
                                list.part_code = item.part_num;
                                list.measureunit = item.measure_unit;
                                list.assist_measureunit=item.mtl_assist_unit
                                list.prior_qty = item.qty_on_hand;
                                list.assist_prior_qty = item.assist_qty_on_hand;//次应有预盘量
                                list.batch_no = item.batch_num;
                                list.sequence_no = item.sequence_num;
                                list.part_version = item.part_version;
                                list.part_name = item.part_name;
                                list.cargo_position = item.cargo_position;
                                list.tmp_exclusively_id = item.exclusively_id;
                                that.list2.push(list);
                            } else {
                                let list = {
                                    exclusively_id: 0,
                                    relation_order_no: '',
                                    line_status: 0,
                                    line_status_name: '生成',
                                    part_code: '',
                                    part_name: '',
                                    part_version: '',
                                    cargo_position: '',
                                    batch_no: '',
                                    sequence_no: '',
                                    line_no: that.line_no_index,
                                    measureunit: '',
                                    prior_qty: 0,
                                    prior_actually_qty: 0,
                                    again_actually_qty: 0,
                                    diff_qty: 0,
                                    assist_measureunit: '',
                                    assist_prior_qty: 0,
                                    assist_prior_actually_qty: 0,
                                    assist_again_actually_qty: 0,
                                    assist_diff_qty: 0,
                                    relation_onhand_id: 0,
                                    workproc_id: 0,
                                    line_net_total_amount: 0,
                                    unit_price: 0,
                                    issue_material_unit: 0,
                                    issue_man_unit: 0,
                                    issue_charge_unit: 0,
                                    issue_material_amount: 0,
                                    issue_man_amount: 0,
                                    issue_charge_amount: 0,
                                    issequencetrace: true
                                };
                                list.relation_onhand_id=item.exclusively_id;
                                list.part_code = item.part_num;
                                list.measureunit = item.measure_unit;                             
                                list.prior_qty = item.qty_on_hand;
                                list.batch_no = item.batch_num;
                                list.sequence_no = item.sequence_num;
                                list.part_version = item.part_version;
                                list.part_name = item.part_name;
                                list.cargo_position = item.cargo_position;
                                list.tmp_exclusively_id = item.exclusively_id;
                                that.list1.push(list);
                            }
                            //that.isShowEdit = false;
                            //that.intidata();
                        });
                    }
                    that.dloading = false;
                });
            },
            //查看备注确定
            mt1() {
                let that = this;
                that.RemarkDialogVisible = false;
                //保存
                that.save();

            },
            //强制关闭原因
            mt2() {
                let that = this;
                that.CloseDialogVisible = false;
                if(that.IsCloseByApi)that.CloseOrder();
            },
            //初盘无差异
            mt3() {
                let that = this;
                that.list1.forEach(item => {
                    console.log(item.prior_qty);
                    item.prior_actually_qty = item.prior_qty;
                });
                that.list2.forEach(item => {
                    item.prior_actually_qty = item.prior_qty;
                    item. assist_prior_actually_qty= item.assist_prior_qty;
                });
            },
            //初盘确认
            mt4() {
                let that = this;
                that.newitem.Lists=[];
                let parm = that.newitem;
                that.list1.forEach(item => {
                    parm.Lists.push(item);
                });
                that.list2.forEach(item => {
                    parm.Lists.push(item);
                });
                that.$http.urlpost('Inv/Check/InvCountDoPriorCount', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.reflash();
                        let rowtmp={
                            Order_No:that.newitem.Head.order_no
                        }
                        that.getDetail(rowtmp);
                    }
                });


            },
            //复盘无差异
            mt5() {
                let that = this;
                that.list1.forEach(item => {
                    //item.again_actually_qty = item.prior_qty;
                    item.again_actually_qty = item.prior_actually_qty;
                });
                that.list2.forEach(item => {
                    //item.again_actually_qty = item.prior_qty;
                    //item.assist_again_actually_qty= item.assist_prior_qty;
                    item.again_actually_qty = item.prior_actually_qty;
                    item.assist_again_actually_qty= item.assist_prior_actually_qty;
                });
            },
            //复盘确认
            mt6() {
                let that = this;
                let parm = that.newitem;
                parm.Lists=[];
                that.list1.forEach(item => {
                    parm.Lists.push(item);
                });
                that.list2.forEach(item => {
                    parm.Lists.push(item);
                });
                that.$http.urlpost('Inv/Check/InvCountDoAgainCount', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.reflash();
                        let rowtmp={
                            Order_No:that.newitem.Head.order_no
                        }
                        that.getDetail(rowtmp);
                    }
                });
            },
            //盘点核准
            mt7() {
                let that = this;
                let parm = that.newitem;
                parm.Lists=[];
                that.list1.forEach(item => {
                    parm.Lists.push(item);
                });
                that.list2.forEach(item => {
                    parm.Lists.push(item);
                });
                that.btn.countverify = false
                that.$http.urlpost('Inv/Check/InvCountCountVerify', parm, function (res) {
                    that.btn.countverify = true
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.reflash();
                        let rowtmp={
                            Order_No:that.newitem.Head.order_no
                        }
                        that.getDetail(rowtmp);
                    }
                });
            },
            //选择盘点条件
            mt8() {
                this.mt8def = true;
                this.$refs.ser.clearInput(true, 'QS_InvCountManageNew');
            },
            //强制关闭
            mt9() {
                let that = this;
                //弹框询问


                this.$confirm(that.$t('getapi[8725]'), that.$t('getapi[194]'), {//确认强制关闭？
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
                }).then(() => {
                    that.CloseDialogVisible = true;
                    that.IsCloseByApi = true;

                }).catch(() => {
                // this.$message({
                // type: 'info',
                // message: '已取消删除'
                // });   
                });

            },
            CloseOrder(){
                let that = this;
                let parm = {
                    Head: {},
                    Lists: []
                };
                if(that.newitem.Head.close_reason==''){
                    that.$message.error(that.$t('getapi[8768]'));//'关闭原因不能为空!'
                    that.IsCloseByApi = false;
                    return;
                }
                parm.Head = that.newitem.Head;
                if (that.list1) {
                    that.list1.forEach(item => {
                        parm.Lists.push(item);
                    });
                }
                if (that.list2) {
                    that.list2.forEach(item => {
                        parm.Lists.push(item);
                    });
                }
                that.$http.urlpost('Inv/Check/InvCountCloseOrder', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        // that.reflash();
                        let rowtmp={
                            Order_No:that.newitem.Head.order_no
                        }
                        that.getDetail(rowtmp);
                    }
                    that.IsCloseByApi = false;
                });
            },
            //执行记账
            mt10() {
                let that = this;
                console.log(that.newitem);
                let parm = {
                    Code: that.newitem.Head.order_no
                };
                that.$http.urlpost('Inv/Check/InvCountFinanceStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        // that.reflash();
                        let rowtmp={
                            Order_No:that.newitem.Head.order_no
                        }
                        that.getDetail(rowtmp);
                    }
                });
            },
            //获得Excel数据
            mt11() {
                this.isuplod = true;
            },
            //数据导入
            mt12() {
                let that = this;
                let parm = {
                    Order_No: that.newitem.Head.order_no,
                    UploadFileUrl: that.UploadFileUrl
                };
                that.$http.urlpost('Inv/Check/InvCountExcelIn', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.reflash();
                    }
                });
            },
            //获取导入模板
            mt13() {
                this.$http.urlpost('Inv/Check/InvCountExportTemplate', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        let hrefurl = res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleChange(file, fileList) {
                let that = this;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 1) {
                        that.UploadFileUrl = file.response.DataContent.URL;
                        that.$message.success(Common.SuccessMsg);
                        that.isuplod = false;
                    }
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 1) {
                    that.UploadFileUrl = Common.Url + res.DataContent.URL;
                    that.$message.success(Common.SuccessMsg);
                    that.isuplod = false;
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            // 详情多选
            linedelsel(e) {
                console.log(e);
                this.lineid = [];
                for (var i = 0; i < e.length; i++) {
                    this.lineid.push(e[i].linid);
                }
            },
            //批量删除
            dellines() {
                let that = this;
                console.log(that.lineid);
                that.lineid.forEach(function (items, indexs) {
                    that.formInline.Lists.forEach(function (item, index) {
                        console.log(items, item.linid);
                        if (items == item.linid) {
                            that.formInline.Lists.splice(index, 1);
                            //that.lineid.splice(indexs, 1);
                        }
                    });
                });
            },
            // 新增s
            addlines() {
                let that = this;
                let dlength = that.formInline.Lists.length;
                let detail = that.formInline.Lists;
                let deti = {
                    linid: dlength,
                    add: false,
                    exclusively_id: 0,
                    relation_id: '',
                    line_no: dlength + 1,
                    co_line_id: 0,
                    co_line_no: '',
                    co_line_part: '',
                    part_version: '',
                    co_line_part_id: 0,
                    co_line_inv_part_num: 0,
                    sales_qty: 0,
                    need_deliver_qty: 0,
                    plan_deliver_qty: 0,
                    qty_onhand: 0,
                    qty_onyuliu: 0,
                    create_person: that.userinfo.username,
                    create_time: '',
                    remark: '',
                    status: 0,
                    statusname: '',
                    item_code: '',
                    item_name: '',
                    cuspart_id: '',
                    cuspart_name: '',
                    customer_item: 0,
                    package_size: 0,
                    isadd: 0
                };
                that.formInline.Lists.push(deti);
            },

            //拖动条中间快捷按钮
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            //点击键盘触发
            show(ev, row) {
                let that = this;
                that.$limits.RemoveScroll();
                let rowtmp={
                            Order_No:row.row.Order_No
                }
                that.getDetail(rowtmp);
                that.authority(2);
            },
            //按住键盘触发
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.dataSet[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.dataSet[index + 1];
                    this.setCurrent(tds);
                }
            },
            //更新表格行状态
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.dataSet.findIndex(item => item.Order_No === val.Order_No);
                    //this.indf = result;

                    //let fsd = document.getElementsByClassName('fsd');
                    //fsd[result].focus();
                    this.currentRow = val;
                    this.authority(2);
                }
            },
            selectInfo(tab){
                let that = this
                that.RightSelectIndex=tab.name
                this.$nextTick(function(){
                    this.$processdata.initFormRight(this.RightSelectIndex)
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 82,1) < 1){
                    return false
                }
                let datacopy = {
                    Head: {},
                    Lists: []
                }
                datacopy.Head = that.newitem.Head
                if (that.list1) {
                    for(let i = 0;i<that.list1.length;i++){
                        datacopy.Lists.push(that.list1[i]);
                    }
                }
                if (that.list2) {
                    for(let i = 0;i<that.list2.length;i++){
                        datacopy.Lists.push(that.list2[i]);
                    }
                }
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                let flag =  that.oldNewitem != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    mright {
        text-align:right;
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-dropdown {
        vertical-align: top;
        background-color: #ffd04b !important;
        border-color: #ffd04b !important;
        color: #ffffff;
        margin-left: 20px;
        padding: 0 14px;
        border-radius: 5px;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto;
            white-space: pre;
            span {
                margin-left: 20px;
                width: 70px;
                text-align: left;
                line-height: 40px;
                display: inline-block;
            }
        }
    }

    span.titles {
        margin-left: 14px;
        margin-right: 15px;
        text-align: left;
        line-height: 40px;
        display: inline-block;
    }
</style>
